import { createLogger } from 'redux-logger';
import { configureStore, EnhancedStore } from '@reduxjs/toolkit';
import createRootReducer from './reducers';

const loggerMiddleware = createLogger();

export default function configureAppStore(): EnhancedStore<RootReducerState, RootActions> {
  return configureStore({
    reducer: createRootReducer(), // Pass the root reducer
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(loggerMiddleware), // Concatenate the logger middleware
  });
}
